import type { useAgencyFlow } from './agency-flow.hook'
import type { useAgencyFlowCanvasDialogs } from './use-agency-flow-canvas-dialogs.hook'
import { useAgencyFlowConnectHandler } from './use-agency-flow-connect-handler.hook'
import { useAgencyFlowEdgeHandlers } from './use-agency-flow-edge-handlers.hook'
import { useAgencyFlowNodeHandlers } from './use-agency-flow-node-handlers.hook'

interface UseCanvasHandlersParams {
  agencyFlow: ReturnType<typeof useAgencyFlow>
  dialogs: ReturnType<typeof useAgencyFlowCanvasDialogs>
  fitView: (options?: object) => void
  screenToFlowPosition: (position: { x: number; y: number }) => { x: number; y: number }
  setIsDrawerOpen: (isOpen: boolean) => void
  isDrawerOpen: boolean
}

export const useAgencyFlowCanvasHandlers = ({
  agencyFlow,
  dialogs,
  fitView,
  screenToFlowPosition,
  setIsDrawerOpen,
  isDrawerOpen,
}: UseCanvasHandlersParams) => {
  const { handleConnectEnd } = useAgencyFlowConnectHandler({ agencyFlow, screenToFlowPosition })
  const nodeHandlers = useAgencyFlowNodeHandlers({ agencyFlow, dialogs, fitView, setIsDrawerOpen })
  const edgeHandlers = useAgencyFlowEdgeHandlers({ agencyFlow, dialogs, isDrawerOpen })

  return {
    ...nodeHandlers,
    ...edgeHandlers,
    handleConnectEnd,
  }
}
